import LoyaltyTierLabel from 'components/Common/Labels/LoyaltyTierLabel'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import type { ReactElement } from 'react'
import { useCallback, useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import ModalContext from 'contexts/ModalContext'
import LandingPageLoyaltyTravelShootCreditBenefitsModal from './LandingPageLoyaltyTravelShootCreditBenefitsModal'

interface Props {
  tier: App.LoyaltyTier
  benefit: App.LoyaltyBenefit
  benefitLabel: ReactElement
}

function LandingPageLoyaltyTravelShootCredit(props: Props) {
  const { tier, benefit, benefitLabel } = props

  const showModal = useContext(ModalContext)
  const intl = useIntl()
  const image = useMemo<App.Image>(() => ({
    id: 'r1z816jjifeqb5hwk50o',
    title: intl.formatMessage({
      id: 'sj_JEhZNdrlz5RwEG5zk',
      defaultMessage: 'Pro photos on your trip',
      description: 'Alternative text fallback for the Travelshoot loyalty benefit image',
    }),
  }), [intl])

  const handleDetailsClick = useCallback(() => {
    showModal(<LandingPageLoyaltyTravelShootCreditBenefitsModal
      image={image}
      benefitValue={benefit.value?.amount ?? 0}
    />)
  }, [benefit, image, showModal])

  return <LandingPageLoyaltyBenefitTile
    heading={intl.formatMessage({
      id: 'sxVMmJF7FoHE2SQkbEvX',
      defaultMessage: 'Pro photos on your trip',
      description: 'Heading for loyalty Travelshoot photo credit benefit tile',
    })}
    labels={<LoyaltyTierLabel kind="primary" tier={tier}>{benefitLabel}</LoyaltyTierLabel>}
    image={image}
    actions={<TextButton kind="secondary" onClick={handleDetailsClick}>
      {intl.formatMessage({
        id: 'aaUpY_wfl1qhPiKJVbUL',
        defaultMessage: 'Details',
        description: 'Link to open Travelshoot credit benefit details modal',
      })}
    </TextButton>}
  >
    <BodyText variant="medium">
      {intl.formatMessage({
        id: 'oqtMS3pCoIsmH5O7wLsf',
        defaultMessage: 'Make the memories last. Use your Travelshoot voucher to book a professional photo session at your destination—perfect for couples, families, or solo travellers.',
        description: 'Description of the Travelshoot professional photo credit loyalty benefit',
      })}
    </BodyText>
  </LandingPageLoyaltyBenefitTile>
}

export default LandingPageLoyaltyTravelShootCredit
